module.exports = __webpack_public_path__ + "img/af8ca2bdf86f4e14801762aa60e4f513-1440.59f137ab.jpg";